import { render, staticRenderFns } from "./Tasks1.container.vue?vue&type=template&id=88bb48be&"
import script from "./Tasks1.container.vue?vue&type=script&lang=js&"
export * from "./Tasks1.container.vue?vue&type=script&lang=js&"
import style0 from "./Tasks1.container.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports